import React, { useEffect, useState } from "react";
import { Card, Grid, Typography } from "@mui/material";
import InputTextField from "../../../components/input/inputTextField";
import { NavigateFunction, useNavigate, useParams } from "react-router-dom";
import NavigateListCustom from "../../../components/navigation/NavigationListCustom";
import { routeName } from "../../../routes/routeName";
import {
  ButtonOutlined,
  ButtonPrimary,
} from "../../../components/button/ButtonCustoms";
import UploadFile from "../../../components/upload/UploadFile";
import { useTranslation } from "react-i18next";
import { advisorRequestApi } from "../../../api/advisor-request/advisor-request.api";
import { useDispatch } from "react-redux";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import CustomStatus from "../../../components/chip/CustomStatus";
import { FiberManualRecord } from "@mui/icons-material";
import DetailCard from "../../../components/card/DetailCard";
import { getFileExtension } from "../../../utils/fileTypeDownload";
import { saveAs } from "file-saver";

const TransferAdvisorRequestHistoryDetail = () => {
  const { t } = useTranslation();
  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const [inputValue, setInputValue] = useState<any>({});
  const [dataTransfer, setDataTransfer] = useState<any>({});

  const fetchGetAdvisorRequestById = async (id: number) => {
    const res = await advisorRequestApi.getSingleAdvisorRequestById(id);
    const data = res.data;
    if (data.status < 300) {
      setInputValue(data.data);
    } else {
      setInputValue({});
    }
  };

  useEffect(() => {
    if (id) {
      fetchGetAdvisorRequestById(parseInt(id));
    }
  }, [id]);

  const fetchGetAdvisorTransferById = async (id: number) => {
    const res = await advisorRequestApi.getSingleAdvisorTransferById(id);
    const data = res.data;
    if (data.status < 300) {
      setDataTransfer(data.data);
    } else {
      setDataTransfer({});
    }
  };

  useEffect(() => {
    if (id) {
      fetchGetAdvisorRequestById(+id);
      fetchGetAdvisorTransferById(+id);
    }
  }, [id]);

  const handleDownloadFile = async (id: number, name_file: string) => {
    dispatch(setLoading());
    await advisorRequestApi
      .downloadFileRequest(id)
      .then((res) => {
        if (res.status < 300) {
          const response = res.data;

          // Get the content type from the server's response headers
          const contentType = res.headers["content-type"];

          // Create a Blob with the content type from the response
          const blob = new Blob([response], { type: contentType });

          // Extract file extension based on content type
          const fileExtension = getFileExtension(contentType || "");

          // Generate a filename with the correct extension (you can also modify this to use a custom name)
          const fileName = `${name_file}.${fileExtension}`;

          // Save the file
          saveAs(blob, fileName);
        }
      })
      .catch((error) => console.log(error))
      .finally(() => dispatch(unsetLoading()));
  };

  const handleColorStatus = (status_type: string) => {
    if (status_type === "draft") {
      return "default";
    } else if (status_type === "รอพิจารณา") {
      return "warning";
    } else if (status_type === "ตอบรับเป็นที่ปรึกษา") {
      return "success";
    } else if (status_type === "ปฏิเสธคำขอ") {
      return "error";
    } else if (status_type === "รออาจารย์ที่ปรึกษาพิจารณาคำร้อง") {
      return "warning";
    } else if (status_type === "รออาจารย์ที่ปรึกษาใหม่พิจารณาคำร้อง") {
      return "warning";
    } else if (status_type === "อนุมัติคำร้องขอเปลี่ยนอาจารย์ที่ปรึกษา") {
      return "info";
    } else if (status_type === "อาจารย์ที่ปรึกษาไม่อนุมัติ") {
      return "error";
    } else if (status_type === "อาจารย์ที่ปรึกษาใหม่ปฏิเสธคำขอ") {
      return "error";
    } else {
      return "warning";
    }
  };

  console.log("dataTransfer", dataTransfer);

  return (
    <div className="h-auto">
      <NavigateListCustom
        navigateData={[
          {
            name: "อาจารย์ที่ปรึกษา",
            key: "1",
            pathName: routeName.student.chooseAdvisor,
          },
          {
            name: `ประวัติการส่งคำร้องขอเปลี่ยนอาจารย์ที่ปรึกษา`,
            key: "2",
            pathName: routeName.student.TransferAdvisor + `/history`,
          },
        ]}
      />

      <section className="w-full mb-12">
        <Typography variant="h3">
          ประวัติการส่งคำร้องขอเปลี่ยนอาจารย์ที่ปรึกษาวิทยานิพนธ์{" "}
          <CustomStatus
            label={inputValue && inputValue.status_request}
            type="outlined"
            color={handleColorStatus(inputValue?.status_request ?? "")}
            icon={<FiberManualRecord />}
          />{" "}
        </Typography>
      </section>

      <section className="w-full mb-12 mt-4">
        <Grid container spacing={2}>
          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            sx={{
              alignSelf: "end",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <DetailCard
              fullname={
                dataTransfer?.old_advisor?.first_name +
                " " +
                dataTransfer?.old_advisor?.last_name
              }
              email={dataTransfer?.old_advisor?.email_organization ?? ""}
              maxStudents={dataTransfer?.old_advisor?.number_students ?? ""}
              requestCount={dataTransfer?.old_advisor?.count_req_all ?? ""}
              advisorCount={dataTransfer?.old_advisor?.count_req ?? ""}
              isSelect={false}
              status={"transfer_1"}
              setIsShowModalSendRequest={() => {}}
              remark={""}
              degree={dataTransfer?.old_advisor?.degree ?? ""}
              faculty={dataTransfer?.old_advisor?.faculty ?? ""}
              year={dataTransfer?.old_advisor?.year ?? ""}
              classRoom={dataTransfer?.old_advisor?.classRoom ?? ""}
              onCancelRequest={() => {}}
              image={dataTransfer?.old_advisor?.file_path ?? ""}
              isTransfer={true}
            />
            <section className="px-4">
              <ButtonPrimary
                onClick={() => {}}
                mode={"transfer"}
                buttonName={""}
                btnProps={{
                  padding: "10px 0px 10px 10px",
                }}
              />
            </section>

            <DetailCard
              fullname={
                dataTransfer?.new_advisor?.first_name +
                " " +
                dataTransfer?.new_advisor?.last_name
              }
              email={dataTransfer?.new_advisor?.email_organization ?? ""}
              maxStudents={dataTransfer?.new_advisor?.number_students ?? ""}
              requestCount={dataTransfer?.new_advisor?.count_req_all ?? ""}
              advisorCount={dataTransfer?.new_advisor?.count_req ?? ""}
              isSelect={false}
              status={"transfer_2"}
              setIsShowModalSendRequest={() => {}}
              remark={""}
              degree={dataTransfer?.new_advisor?.degree ?? ""}
              faculty={dataTransfer?.new_advisor?.faculty ?? ""}
              year={dataTransfer?.new_advisor?.year ?? ""}
              classRoom={dataTransfer?.new_advisor?.classRoom ?? ""}
              onCancelRequest={() => {}}
              image={dataTransfer?.new_advisor?.file_path ?? ""}
              isTransfer={true}
            />
          </Grid>
        </Grid>
      </section>

      <section className="my-4">
        <InputTextField
          heading={"เหตุผลจากนักศึกษา"}
          placeholder={"เหตุผลจากนักศึกษา"}
          value={dataTransfer?.advisor_reason ?? ""}
          disabled={true}
          row={3}
          maxRows={5}
          disablePaddingMultiline
          multiline
          inputHeight={"auto"}
        />
      </section>

      {(inputValue && inputValue.status_request === "ปฏิเสธคำขอ") ||
      inputValue.status_request === "อาจารย์ที่ปรึกษาใหม่ปฏิเสธคำขอ" ? (
        <section className="my-4">
          <InputTextField
            heading={"เหตุผลที่ปฏิเสธ"}
            placeholder={"เหตุผลที่ปฏิเสธ"}
            value={inputValue.advisor_refuse ?? ""}
            disabled={true}
            row={3}
            maxRows={5}
            disablePaddingMultiline
            multiline
            inputHeight={"auto"}
          />
        </section>
      ) : null}

      <section className="my-4 flex justify-center">
        <ButtonOutlined
          onClick={() => {
            navigate(routeName.student.TransferAdvisorRequestHistory);
          }}
          mode="del"
          buttonName="ย้อนกลับ"
          btnProps={{
            width: "125px",
          }}
        />
      </section>
    </div>
  );
};

export default TransferAdvisorRequestHistoryDetail;
